/* eslint-disable */
import { useEffect, useMemo } from 'react';
import MultiPOGeneralDetails from '@/Components/Modals/MultiPoModal/MultiPOGeneralDetails';
import { apiFetchers, runApiFetch } from './createOrdersApiConfig';
import { detailsLayoutConfig } from './createOrdersUiHelpers';

const FormStep = ({
	stepCfg,
	stepConfig,
	category,
	modeName,
	state,
	lists,
	onStateChange,
	onListsChange,
}) => {

	const fetchField = async (fieldId, stateArg) => {
		const entry = apiFetchers?.[fieldId];
		if (!entry?.listKey) return;
		if (entry.fetchOnce && lists?.[entry.listKey]?.length) return;
		try {
			const data = await runApiFetch(fieldId, { state: stateArg, lists });
			if (data) {
				onListsChange?.(entry.listKey, data);
			}
		} catch (error) {
			console.error(`Error fetching ${fieldId}:`, error);
		}
	};

	useEffect(() => {
		(stepCfg?.fieldApis?.onMount || []).forEach((fieldId) => {
			const entry = apiFetchers?.[fieldId];
			if (entry?.listKey && lists?.[entry.listKey]?.length) return;
			fetchField(fieldId, state);
		});
	}, []);

	const handleFieldChange = (fieldId, value) => {
		const next = { ...state, [fieldId]: value };
		const dependents = stepCfg?.fieldApis?.onChange?.[fieldId] || [];
		dependents.forEach((depId) => {
			next[depId] = null;
		});
		onStateChange?.(next);
		dependents.forEach((depId) => fetchField(depId, next));
	};

	const stepFields = useMemo(() => {
		const ids = stepCfg?.fields;
		const all = stepConfig?.fields || [];
		const picked = ids?.length
			? ids.map((id) => all.find((f) => f.id === id)).filter(Boolean)
			: all;
		return picked.map((field) => {
			let out = field;
			if (field.id === 'orderType' && category?.orderType) {
				out = { ...out, tabOptions: [category.orderType] };
			}
			const labelIcon = stepCfg?.fieldIcons?.[field.id];
			if (labelIcon) {
				out = { ...out, labelIcon };
			}
			return out;
		});
	}, [stepCfg, stepConfig, category?.orderType]);

	return (
		<div className='h-full bg-gray-50/60 px-6 py-8'>
			<div className='mx-auto max-w-[980px] rounded-xl border border-gray-200 bg-white p-7 shadow-sm'>
				<div className='mb-6 border-b border-gray-100 pb-4'>
					<p className='text-left text-[17px] font-bold text-gray-900'>
						{stepCfg?.card?.title || 'Basic Details'}
					</p>
					{stepCfg?.card?.subtitle && (
						<p className='mt-1 text-left text-[13px] text-gray-500'>
							{stepCfg.card.subtitle}
						</p>
					)}
				</div>
				<MultiPOGeneralDetails
					fields={stepFields}
					lists={lists}
					onFieldChange={handleFieldChange}
					externalState={state}
					modeName={modeName}
					layoutConfig={detailsLayoutConfig(stepCfg)}
				/>
			</div>
		</div>
	);
};

export default FormStep;
